import clienteAxios from "../config/axios";

export async function getAllNivel1() {
    return clienteAxios.get(`/nivel1`);
}

export async function addNivel1(dato) {
    const codNivel1 = dato.codNivel1
    const name = dato.name
    const descrp =  dato.descrp
    const direccion = dato.direccion || null
    const lat = dato.lat || null
    const lng = dato.lng || null
    return clienteAxios.post(`/nivel1`,{codNivel1, name, descrp, direccion, lat, lng});
}

export async function updateNivel1(dato) {
    const id = dato.id
    const updates = {
        id: dato.id,
        codNivel1:dato.codNivel1,
        name: dato.name,
        descrp: dato.descrp,
        direccion: dato.direccion || null,
        lat: dato.lat || null,
        lng: dato.lng || null
    }
    return clienteAxios.put(`/nivel1/${id}`,updates);
}

export async function deleteNivel1(id) {
    return clienteAxios.delete(`/nivel1/${id}`,id);
}
export async function deleteNivel1AndChildren(id, deleteActivesToo) {
    return clienteAxios.delete(`/nivel1/deleteLevelAndChildren/${id}?deleteActivesToo=${deleteActivesToo}`,{id});
}

export async function getChildrensOfLv1(id){
    return clienteAxios.get(`/nivel1/${id}`);
}

export async function updatePositioning(updates){
    return clienteAxios.post(`/nivel1/updatePositioning`,{updates});
}